import { Injectable } from '@angular/core';
import { BaseclientService } from '../baseclient.service';

@Injectable({
  providedIn: 'root'
})

export class CitiesService {

  constructor(
    private baseClient: BaseclientService,
  ) { }

  getCities(idCountry: any, postal: any): Promise<any> {
    const params = { id_country: idCountry, postal: postal };
    return this.baseClient.postBase("getCities", params);
  }

  getPostals(idCountry: any, value: string): Promise<any> {
    const params = { id_country: idCountry, value: value };
    return this.baseClient.postBase("getPostals", params);
  }
}
